import { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useSelector } from 'src/store';

interface SidebarLayoutProps {
  children?: ReactNode;
}

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  // Obtener el ID de la productora seleccionada para usarlo como key
  // Esto fuerza el re-mount de los componentes cuando cambia la productora
  const { selectedProducer } = useSelector((state) => state.auth);
  const producerKey = selectedProducer?.id || 'default';

  return (
    <>
      <Sidebar />
      <Box>
        <Header />
        {/* Key basada en productora: fuerza re-mount cuando cambia */}
        <Box key={producerKey}>
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default SidebarLayout;
